import type { NotificationProps } from '@ui/components/Notification/Notification';
import { useTranslations } from '@ui/i18n';

import type { StatsChartPage } from './useStatsCharts';

export const useStatsQA = (page: StatsChartPage) => {
  const t = useTranslations();
  const toNotification = (qa: {
    title: string;
    longText: string;
  }): NotificationProps => ({ ...qa, text: qa.longText.slice(0, 81) + '...' });

  const statsQaStaking: NotificationProps[] = [
    {
      title: t("Where can I find Veno Finance's liquid staking analytics?"),
      longText: t(
        "Where can I find Veno Finance's liquid staking analytics?answer",
      ),
    },
    {
      title: t('What liquid staking stats are available for CRO and ATOM?'),
      longText: t(
        'What liquid staking stats are available for CRO and ATOM?answer',
      ),
    },
    {
      title: t(
        'Can I analyze historical liquid staking volumes on Veno Finance?',
      ),
      longText: t(
        'Can I analyze historical liquid staking volumes on Veno Finance?answer',
      ),
    },
  ].map(toNotification);
  const statsQaVno: NotificationProps[] = [
    {
      title: t(
        'How might scheduled unlocks of locked tokens influence circulating supply?',
      ),
      longText: t(
        'How might scheduled unlocks of locked tokens influence circulating supply?answer',
      ),
    },
    {
      title: t(
        'Can historical token emissions be used to estimate metrics related to circulating supply?',
      ),
      longText: t(
        'Can historical token emissions be used to estimate metrics related to circulating supply?answer',
      ),
    },
    {
      title: t(
        'What public data is available to evaluate dynamics between locked and circulating token amounts?',
      ),
      longText: t(
        'What public data is available to evaluate dynamics between locked and circulating token amounts?answer',
      ),
    },
  ].map(toNotification);

  return page === 'vno' ? statsQaVno : statsQaStaking;
};
